import pixAxios from '@/axios/pixAxios.js';
import moment from 'moment';
import Vue from 'vue';

const notificationsModule = {
  namespaced: true,
  state: {
    totalNotifications: 0,
    notifications: [],
    openMenu: false,
  },
  actions: {
    startFetchingNotifications({ dispatch, commit }) {
      const lastNotificationGetDate = sessionStorage.getItem('LastNotificationGetDate');
      const now = moment(Date.now());
      const then = moment(Number(lastNotificationGetDate));
      if (!lastNotificationGetDate || moment.duration(now.diff(then)).asMinutes() > 10) {
        dispatch('fetchNotifications');
      } else {
        const rawNotifications = JSON.parse(sessionStorage.getItem('Notifications'));
        const totalNotifications = JSON.parse(sessionStorage.getItem('TotalNotifications'));
        const numberUnreadNotifications = JSON.parse(sessionStorage.getItem('NumberUnreadNotifications'));
        commit('setNotifications', rawNotifications);
        commit('setTotalNotifications', totalNotifications);
        commit('setUnreadNotifications', numberUnreadNotifications);
      }
    },
    fetchNotifications({ state, commit }) {
      pixAxios
        .post('api/Notification/GetActiveNotifications', {
          page: 1,
          rows: 30,
          skip: state.notifications.length,
        })
        .then((response) => {
          if (response.data) {
            if (Array.isArray(response.data.rows)) {
              if (state.notifications.length === 0) {
                sessionStorage.setItem('LastNotificationGetDate', Date.now());
              }
              commit('setNotifications', [...state.notifications, ...response.data.rows]);
              commit('setTotalNotifications', response.data.total);
              commit('setUnreadNotifications', response.data.NotReadNotifications);
            }
          }
        });
    },
    setOpenMenu({ commit }, payload) {
      commit('setOpenMenu', payload);
    },
    toggleOpenMenu({ commit, state }) {
      commit('setOpenMenu', !state.openMenu);
    },
    setNotificationRead({ commit, state }, NotificationId) {
      pixAxios.post('api/Notification/ReadNotification', { NotificationId }).then(() => {
        commit('setNotificationStatus', { NotificationId, newStatus: false });
        commit('setUnreadNotifications', state.numberOfUnreadNotifications - 1);
      });
    },
    setNotificationUnread({ commit, state }, NotificationId) {
      pixAxios.post('api/Notification/UnreadNotification', { NotificationId }).then(() => {
        commit('setNotificationStatus', { NotificationId, newStatus: true });
        commit('setUnreadNotifications', state.numberOfUnreadNotifications + 1);
      });
    },
    toggleNotificationStatus({ dispatch }, notification) {
      if (notification.read) {
        dispatch('setNotificationUnread', notification);
      } else {
        dispatch('setNotificationRead', notification);
      }
    },
    deleteNotification({ commit }, NotificationId) {
      pixAxios.post('api/Notification/DeleteNotification', { NotificationId }).then(() => {
        commit('deleteNotification', NotificationId);
      });
    },
  },
  mutations: {
    setNotifications(state, newValue) {
      state.notifications = newValue;
      sessionStorage.setItem('Notifications', JSON.stringify(state.notifications));
    },
    setTotalNotifications(state, newValue) {
      state.totalNotifications = newValue;
      sessionStorage.setItem('TotalNotifications', JSON.stringify(newValue));
    },
    setOpenMenu(state, newValue) {
      state.openMenu = newValue;
    },
    setNotificationStatus(state, { NotificationId, newStatus }) {
      const index = state.notifications.findIndex((notification) => notification.NotificationId === NotificationId);
      Vue.set(state.notifications[index], 'IsUnread', newStatus);
      sessionStorage.setItem('Notifications', JSON.stringify(state.notifications));
    },
    deleteNotification(state, NotificationId) {
      const index = state.notifications.findIndex((notification) => notification.NotificationId === NotificationId);
      state.notifications.splice(index, 1);
      sessionStorage.setItem('Notifications', JSON.stringify(state.notifications));
    },
    setUnreadNotifications(state, numberOfUnreadNotifications) {
      Vue.set(state, 'numberOfUnreadNotifications', numberOfUnreadNotifications);
      sessionStorage.setItem('NumberUnreadNotifications', JSON.stringify(numberOfUnreadNotifications));
    },
  },
  getters: {
    getNotifications(state) {
      return state.notifications;
    },

    getTotalNotifications(state) {
      return state.totalNotifications;
    },

    getNumberOfUnreadNotifications(state) {
      // todo this is not a proper calculation of the number of notifications quick workaround for now
      return state.numberOfUnreadNotifications ?? 0;
    },

    getNotificationsByDate(state, getters, rootState, rootGetters) {
      const notificationsByDate = new Map();
      state.notifications.forEach((notification) => {
        const previousNotifications = notificationsByDate.get(moment(notification.NotificationDate).format(rootGetters.backendDateFormat));
        if (previousNotifications) {
          notificationsByDate.set(moment(notification.NotificationDate).format(rootGetters.backendDateFormat), [...previousNotifications, notification]);
        } else {
          notificationsByDate.set(moment(notification.NotificationDate).format(rootGetters.backendDateFormat), [notification]);
        }
      });
      return notificationsByDate;
    },
    getOrderedNotifications(state, getters) {
      const orderedEntries = [...getters.getNotificationsByDate.entries()]
        .map((entry) => {
          return { date: entry[0], notifications: entry[1] };
        })
        .sort((notifications1, notifications2) => {
          return moment(notifications2.date) - moment(notifications1.date);
        });
      return orderedEntries;
    },
    getOpenMenu(state) {
      return state.openMenu;
    },
  },
};

export default notificationsModule;
